import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const USER_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'pending', label: 'Pending' },
  { value: 'banned', label: 'Banned' },
  { value: 'rejected', label: 'Rejected' },
];

export const _userAbout = {
  id: _mock.id(1),
  role: _mock.role(1),
  email: _mock.email(1),
  school: _mock.companyNames(2),
  company: _mock.companyNames(1),
  country: _mock.countryNames(2),
  coverUrl: _mock.image.cover(3),
  totalFollowers: _mock.number.nativeL(1),
  totalFollowing: _mock.number.nativeL(2),
  quote:
    'Tart I love sugar plum I love oat cake. Sweet roll caramels I love jujubes. Topping cake wafer..',
  socialLinks: {
    facebook: `https://www.facebook.com/caitlyn.kerluke`,
    instagram: `https://www.instagram.com/caitlyn.kerluke`,
    linkedin: `https://www.linkedin.com/in/caitlyn.kerluke`,
    twitter: `https://www.twitter.com/caitlyn.kerluke`,
  },
};

export const _userFollowers = Array.from({ length: 18 }, (_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  country: _mock.countryNames(index),
  avatarUrl: _mock.image.avatar(index),
}));

export const _userFriends = Array.from({ length: 18 }, (_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
}));

export const _userGallery = Array.from({ length: 12 }, (_, index) => ({
  id: _mock.id(index),
  postedAt: _mock.time(index),
  title: _mock.postTitle(index),
  imageUrl: _mock.image.cover(index),
}));

export const _userFeeds = Array.from({ length: 3 }, (_, index) => ({
  id: _mock.id(index),
  createdAt: _mock.time(index),
  media: _mock.image.travel(index + 1),
  message: _mock.sentence(index),
  personLikes: Array.from({ length: 20 }, (__, personIndex) => ({
    name: _mock.fullName(personIndex),
    avatarUrl: _mock.image.avatar(personIndex + 2),
  })),
  comments: (index === 2 && []) || [
    {
      id: _mock.id(7),
      author: {
        id: _mock.id(8),
        avatarUrl: _mock.image.avatar(index + 5),
        name: _mock.fullName(index + 5),
      },
      createdAt: _mock.time(2),
      message: 'Praesent venenatis metus at',
    },
    {
      id: _mock.id(9),
      author: {
        id: _mock.id(10),
        avatarUrl: _mock.image.avatar(index + 6),
        name: _mock.fullName(index + 6),
      },
      createdAt: _mock.time(3),
      message:
        'Etiam rhoncus. Nullam vel sem. Pellentesque libero tortor, tincidunt et, tincidunt eget, semper nec, quam. Sed lectus.',
    },
  ],
}));

export const _userCards = Array.from({ length: 21 }, (_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  coverUrl: _mock.image.cover(index),
  avatarUrl: _mock.image.avatar(index),
  totalFollowers: _mock.number.nativeL(index),
  totalPosts: _mock.number.nativeL(index + 2),
  totalFollowing: _mock.number.nativeL(index + 1),
}));

export const _userPayment = Array.from({ length: 3 }, (_, index) => ({
  id: _mock.id(index),
  cardNumber: ['**** **** **** 1234', '**** **** **** 5678', '**** **** **** 7878'][index],
  cardType: ['mastercard', 'visa', 'visa'][index],
  primary: index === 1,
}));

export const _userAddressBook = Array.from({ length: 4 }, (_, index) => ({
  id: _mock.id(index),
  primary: index === 0,
  name: _mock.fullName(index),
  phoneNumber: _mock.phoneNumber(index),
  fullAddress: _mock.fullAddress(index),
  addressType: (index === 0 && 'Home') || 'Office',
}));

export const _userInvoices = Array.from({ length: 10 }, (_, index) => ({
  id: _mock.id(index),
  invoiceNumber: `INV-199${index}`,
  createdAt: _mock.time(index),
  price: _mock.number.price(index),
}));

export const _userPlans = [
  { subscription: 'basic', price: 0, primary: false },
  { subscription: 'starter', price: 4.99, primary: true },
  { subscription: 'premium', price: 9.99, primary: false },
];

export const _userList = Array.from({ length: 20 }, (_, index) => ({
  id: _mock.id(index),
  zipCode: '85807',
  state: 'Virginia',
  city: 'Rancho Cordova',
  role: _mock.role(index),
  email: _mock.email(index),
  address: '908 Jack Locks',
  name: _mock.fullName(index),
  isVerified: _mock.boolean(index),
  company: _mock.companyNames(index),
  country: _mock.countryNames(index),
  avatarUrl: _mock.image.avatar(index),
  phoneNumber: _mock.phoneNumber(index),
  status: (index % 2 && 'inactive') || 'active',
  username: _mock.fullName(index),
  joinedDate: '27 Feb 2025',
  teamName: _mock.fullName(index),
  noOfUsers: Math.round(Math.random() * 100),
  createdDate: '28 Feb 2025',
  didNumber: index * Math.round(Math.random() * 100000),
}));

export const TICKETS: {
  id: string;
  subject: string;
  status: string;
  assigned_to: string;
  created_date: string;
  priority: string;
  action: string;
}[] = [
  {
    id: '1',
    subject: 'Login Issue',
    status: 'Active',
    assigned_to: 'John Doe',
    created_date: '2025-02-10',
    priority: 'High',
    action: 'View',
  },
  {
    id: '2',
    subject: 'Payment Failure',
    status: 'In Progress',
    assigned_to: 'Jane Smith',
    created_date: '2025-02-09',
    priority: 'Medium',
    action: 'View',
  },
  {
    id: '3',
    subject: 'Bug in Dashboard',
    status: 'Inactive',
    assigned_to: 'Robert Brown',
    created_date: '2025-02-08',
    priority: 'Low',
    action: 'View',
  },
  {
    id: '4',
    subject: 'Email Not Received',
    status: 'Active',
    assigned_to: 'Emily Johnson',
    created_date: '2025-02-07',
    priority: 'High',
    action: 'View',
  },
  {
    id: '5',
    subject: 'Page Load Slow',
    status: 'Inactive',
    assigned_to: 'Michael Lee',
    created_date: '2025-02-06',
    priority: 'Medium',
    action: 'View',
  },
  {
    id: '6',
    subject: 'Error 500 on Checkout',
    status: 'In Progress',
    assigned_to: 'Sarah Wilson',
    created_date: '2025-02-05',
    priority: 'Critical',
    action: 'View',
  },
  {
    id: '7',
    subject: 'Profile Picture Not Updating',
    status: 'Inactive',
    assigned_to: 'David Martinez',
    created_date: '2025-02-04',
    priority: 'Low',
    action: 'View',
  },
  {
    id: '8',
    subject: 'Two-Factor Authentication Issue',
    status: 'Active',
    assigned_to: 'Chris Taylor',
    created_date: '2025-02-03',
    priority: 'High',
    action: 'View',
  },
  {
    id: '9',
    subject: 'Billing Discrepancy',
    status: 'Active',
    assigned_to: 'Anna Harris',
    created_date: '2025-02-02',
    priority: 'Medium',
    action: 'View',
  },
  {
    id: '10',
    subject: 'Live Chat Not Working',
    status: 'In Progress',
    assigned_to: 'James White',
    created_date: '2025-02-01',
    priority: 'High',
    action: 'View',
  },
];

export const accountListData = [
  {
    id: '1',
    account_name: 'ABC Corp',
    website: 'https://abc.com',
    email: 'contact@abc.com',
    contact_number: '+1234567890',
    address: '123 Main St, City',
    owner: 'John Doe',
    status: 'Active',
    rating: 5,
    type: 'Enterprise',
    action: 'Edit',
  },
  {
    id: '2',
    account_name: 'XYZ Ltd',
    website: 'https://xyz.com',
    email: 'support@xyz.com',
    contact_number: '+9876543210',
    address: '456 Market St, Town',
    owner: 'Jane Smith',
    status: 'Inactive',
    rating: 4,
    type: 'SMB',
    action: 'Edit',
  },
  {
    id: '3',
    account_name: 'Global Tech',
    website: 'https://globaltech.com',
    email: 'info@globaltech.com',
    contact_number: '+1112223333',
    address: '789 Silicon Valley, CA',
    owner: 'Alice Johnson',
    status: 'Active',
    rating: 5,
    type: 'Startup',
    action: 'Edit',
  },
  {
    id: '4',
    account_name: 'NextGen Solutions',
    website: 'https://nextgen.com',
    email: 'hello@nextgen.com',
    contact_number: '+3332221111',
    address: '101 Innovation Rd, NY',
    owner: 'Michael Brown',
    status: 'Pending',
    rating: 3,
    type: 'Enterprise',
    action: 'Edit',
  },
  {
    id: '5',
    account_name: 'Digital Wave',
    website: 'https://digitalwave.com',
    email: 'sales@digitalwave.com',
    contact_number: '+4445556666',
    address: '500 Ocean Drive, Miami',
    owner: 'Sarah White',
    status: 'Active',
    rating: 4,
    type: 'SMB',
    action: 'Edit',
  },
  {
    id: '6',
    account_name: 'Innovate Hub',
    website: 'https://innovatehub.com',
    email: 'team@innovatehub.com',
    contact_number: '+5556667777',
    address: '99 Startup Blvd, SF',
    owner: 'Robert Green',
    status: 'Inactive',
    rating: 2,
    type: 'Startup',
    action: 'Edit',
  },
  {
    id: '7',
    account_name: 'Pioneer Systems',
    website: 'https://pioneersys.com',
    email: 'admin@pioneersys.com',
    contact_number: '+8887776666',
    address: '75 Tech Park, Austin',
    owner: 'Emily Adams',
    status: 'Active',
    rating: 5,
    type: 'Enterprise',
    action: 'Edit',
  },
  {
    id: '8',
    account_name: 'Visionary Inc',
    website: 'https://visionary.com',
    email: 'contact@visionary.com',
    contact_number: '+7778889999',
    address: '200 Future Lane, Seattle',
    owner: 'David Lee',
    status: 'Pending',
    rating: 3,
    type: 'SMB',
    action: 'Edit',
  },
  {
    id: '9',
    account_name: 'Growth Labs',
    website: 'https://growthlabs.com',
    email: 'growth@growthlabs.com',
    contact_number: '+2223334444',
    address: '11 Business Street, LA',
    owner: 'Olivia Martin',
    status: 'Active',
    rating: 4,
    type: 'Startup',
    action: 'Edit',
  },
  {
    id: '10',
    account_name: 'Future Tech',
    website: 'https://futuretech.com',
    email: 'future@futuretech.com',
    contact_number: '+9990001111',
    address: '42 Digital Road, Chicago',
    owner: 'William Brown',
    status: 'Inactive',
    rating: 2,
    type: 'Enterprise',
    action: 'Edit',
  },
];

export const campaignListData = [
  {
    broadcast_name: 'New Year Campaign',
    created_date: '2025-02-01',
    created_by: 'John Doe',
    recipients: 4,
    sent: 3,
    delivered: 2,
    read: 2,
    failed: 0,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Product Launch',
    created_date: '2025-02-02',
    created_by: 'Jane Smith',
    recipients: 10,
    sent: 5,
    delivered: 9,
    read: 8,
    failed: 5,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Feedback Request',
    created_date: '2025-02-03',
    created_by: 'Emily Johnson',
    recipients: 7,
    sent: 7,
    delivered: 6,
    read: 6,
    failed: 3,
    status: 'In progress',
    action: 'View',
  },
  {
    broadcast_name: 'Spring Sale',
    created_date: '2025-02-04',
    created_by: 'Michael Brown',
    recipients: 12,
    sent: 11,
    delivered: 11,
    read: 10,
    failed: 1,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Holiday Greetings',
    created_date: '2025-02-05',
    created_by: 'Sophia Wilson',
    recipients: 3,
    sent: 2,
    delivered: 2,
    read: 2,
    failed: 1,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Survey Invitation',
    created_date: '2025-02-06',
    created_by: 'William Martinez',
    recipients: 6,
    sent: 5,
    delivered: 5,
    read: 5,
    failed: 2,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Flash Sale Alert',
    created_date: '2025-02-07',
    created_by: 'Olivia Davis',
    recipients: 9,
    sent: 8,
    delivered: 8,
    read: 8,
    failed: 5,
    status: 'In progress',
    action: 'View',
  },
  {
    broadcast_name: 'Event Reminder',
    created_date: '2025-02-08',
    created_by: 'James Taylor',
    recipients: 4,
    sent: 4,
    delivered: 4,
    read: 3,
    failed: 2,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Limited Offer',
    created_date: '2025-02-09',
    created_by: 'Isabella White',
    recipients: 11,
    sent: 10,
    delivered: 10,
    read: 9,
    failed: 5,
    status: 'Completed',
    action: 'View',
  },
  {
    broadcast_name: 'Loyalty Rewards',
    created_date: '2025-02-10',
    created_by: 'Ethan Harris',
    recipients: 8,
    sent: 7,
    delivered: 7,
    read: 7,
    failed: 3,
    status: 'In progress',
    action: 'View',
  },
];

const templatesData = [
  {
    status: 'Approved',
    title: 'Template_1',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: '',
  },
  {
    status: 'Approved',
    title: 'Template_2',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: 'image',
  },
  {
    status: 'Approved',
    title: 'Template_3',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: 'link',
  },
  {
    status: 'Approved',
    title: 'Template_4',
    message:
      'Hi [Name], \nThanks for reaching out! We’ve received your inquiry about [Product/Service]. Our team will review your request and get back to you within [X] hours.',
    additionalInfo: 'If you have any questions in the meantime, don’t hesitate to contact us!',
    timestamp: '12 Feb 2025 12:00 PM',
    mediatype: 'media',
  },
];

const audienceData = [
  {
    name: 'John Doe',
    number: '+1 555-1234',
    email: 'johndoe@example.com',
    city: 'New York',
    state: 'NY',
    label: 'VIP',
  },
  {
    name: 'Jane Smith',
    number: '+1 555-5678',
    email: 'janesmith@example.com',
    city: 'Los Angeles',
    state: 'CA',
    label: 'New Custom',
  },
  {
    name: 'Michael Brown',
    number: '+1 555-8765',
    email: 'michaelbrown@example.com',
    city: 'Chicago',
    state: 'IL',
    label: 'High Priority',
  },
  {
    name: 'Emily Johnson',
    number: '+1 555-4321',
    email: 'emilyjohnson@example.com',
    city: 'Houston',
    state: 'TX',
    label: 'VIP',
  },
  {
    name: 'David Lee',
    number: '+1 555-6543',
    email: 'davidlee@example.com',
    city: 'San Francisco',
    state: 'CA',
    label: 'New Custom',
  },
  {
    name: 'Sarah Miller',
    number: '+1 555-9876',
    email: 'sarahmiller@example.com',
    city: 'Miami',
    state: 'FL',
    label: 'High Priority',
  },
  {
    name: 'Robert Wilson',
    number: '+1 555-2468',
    email: 'robertwilson@example.com',
    city: 'Seattle',
    state: 'WA',
    label: 'VIP',
  },
  {
    name: 'Olivia Martinez',
    number: '+1 555-3697',
    email: 'oliviamartinez@example.com',
    city: 'Denver',
    state: 'CO',
    label: 'New Custom',
  },
  {
    name: 'Daniel Anderson',
    number: '+1 555-1597',
    email: 'danielanderson@example.com',
    city: 'Boston',
    state: 'MA',
    label: 'High Priority',
  },
  {
    name: 'Sophia Thomas',
    number: '+1 555-7531',
    email: 'sophiathomas@example.com',
    city: 'Dallas',
    state: 'TX',
    label: 'VIP',
  },
];

export const planlistData = (t: any) => [
  {
    name: t('PURCHASE_PLAN'),
    value: 'purchase_plan',
  },
  {
    name: t('BUY_PHONENO'),
    value: 'buy_phone_number',
  },
  {
    name: t('BUY_CALL_CREDITS'),
    value: 'buy_call_credits',
  },
  {
    name: t('BUY_WA_MSG_CREDITS'),
    value: 'buy_whatsapp_credits',
  },
];

export const _labelList = [
  {
    id: '1',
    labelName: 'Sales',
    labelType: 'Contact',
    labelDescription: 'Handles client deals',
    labelColor: '#118D57',
  },
  {
    id: '2',
    labelName: 'Support',
    labelType: 'Conversation',
    labelDescription: 'Customer issue resolution',
    labelColor: '#B71D18',
  },
  {
    id: '3',
    labelName: 'Customer',
    labelType: 'Ticket',
    labelDescription: 'Existing client management',
    labelColor: '#D29F50',
  },
  {
    id: '4',
    labelName: 'Lead',
    labelType: 'Conversation',
    labelDescription: 'Potential client engagement',
    labelColor: '#B71D18',
  },
  {
    id: '5',
    labelName: 'Marketing',
    labelType: 'Campaign',
    labelDescription: 'Promotes brand awareness',
    labelColor: '#B71D18',
  },
  {
    id: '6',
    labelName: 'Development',
    labelType: 'Project',
    labelDescription: 'Builds product features',
    labelColor: '#B71D18',
  },
  {
    id: '7',
    labelName: 'Finance',
    labelType: 'Account',
    labelDescription: 'Manages company funds',
    labelColor: '#B71D18',
  },
  {
    id: '8',
    labelName: 'HR',
    labelType: 'Recruitment',
    labelDescription: 'Handles employee relations',
    labelColor: '#B71D18',
  },
  {
    id: '9',
    labelName: 'Operations',
    labelType: 'Management',
    labelDescription: 'Oversees daily processes',
    labelColor: '#B71D18',
  },
  {
    id: '10',
    labelName: 'Partnership',
    labelType: 'Collaboration',
    labelDescription: 'Manages business alliances',
    labelColor: '#B71D18',
  },
];

export const callList = {
  calls: [
    {
      name: 'Lucian Obrien',
      avatar: 'Lucian Obrien',
      phone: '102',
      date: 'Jan 10 2025',
      time: '8:50 PM',
      duration: '02:00',
      icon: {
        name: 'solar:arrow-left-down-linear',
        color: '#2B8DEA',
      },
    },
    {
      name: 'Lucian Obrien',
      avatar: 'Lucian Obrien',
      phone: '102',
      date: 'Jan 10 2025',
      time: '8:50 PM',
      duration: '02:00',
      icon: {
        name: 'solar:arrow-right-up-linear',
        color: 'success.main',
      },
    },
    {
      name: 'Lucian Obrien',
      avatar: 'Lucian Obrien',
      phone: '102',
      date: 'Jan 10 2025',
      time: '8:50 PM',
      duration: '02:00',
      icon: {
        name: 'mage:phone-missed-call-fill',
        color: 'error.main',
      },
    },
    {
      name: 'Lucian Obrien',
      avatar: 'Lucian Obrien',
      phone: '102',
      date: 'Jan 10 2025',
      time: '8:50 PM',
      duration: '02:00',
      icon: {
        name: 'material-symbols-light:phone-disabled',
      },
    },
    {
      name: 'Lucian Obrien',
      avatar: 'Lucian Obrien',
      phone: '102',
      date: 'Jan 10 2025',
      time: '8:50 PM',
      duration: '02:00',
      icon: {
        name: 'subway:call-4',
      },
    },
  ],
};

export const _dashboadedCallList = (t: any) => [
  {
    title: t('INCOMING_CALLS'),
    total: 40,
    duration: '14:12:30',
    type: 'incoming_calls',
  },
  {
    title: t('OUTGOING_CALLS'),
    total: 25,
    duration: '10:45:20',
    type: 'outgoing_calls',
  },
  {
    title: t('MISSED_CALLS'),
    total: 15,
    duration: '00:00:00',
    type: 'missed_calls',
  },
  {
    title: t('TOTAL_CALLS'),
    total: 80,
    duration: '24:57:50',
    type: 'total_calls',
  },
];

export const _conversationsList = (t: any) => [
  {
    title: t('CONVERSATION_OPEN'),
    total: 23,
    icon: 'assets/icons/courses/ic-courses-progress.svg',
  },
  {
    title: t('CONVERSATION_UNATTENDED'),
    total: 3,
    color: 'info',
    icon: 'assets/icons/courses/ic-conversation-unattended.svg',
  },
  {
    title: t('CONVERSATION_UNASSIGNED'),
    total: 2,
    color: 'secondary',
    icon: 'assets/icons/courses/ic-conversation-unassigned.svg',
  },
  {
    title: t('CONVERSATION_CLOSE'),
    total: 2,
    color: 'success',
    icon: 'assets/icons/courses/ic-courses-completed.svg',
  },
];

export const channelListData = [
  {
    channel_name: 'Variance Voice Call',
    icon: 'assets/icons/navbar/ic-variance-voice.svg',
  },
  {
    channel_name: 'Support Email',
    icon: 'assets/icons/navbar/ic-variance-mail.svg',
  },
  {
    channel_name: 'Variance WhatsApp',
    icon: 'assets/icons/navbar/ic-variance-whatsapp-business.svg',
  },
  {
    channel_name: 'Support WhatsApp',
    icon: 'assets/icons/navbar/ic-variance-whatsapp-business.svg',
  },
  {
    channel_name: 'Variance Email',
    icon: 'assets/icons/navbar/ic-variance-mail.svg',
  },
];

export const channelStep1Data = (t: any) => [
  {
    channel_name: t('WHATSAPP_BUSINESS'),
    value: 'WHATSAPP',
    icon: '/assets/icons/navbar/ic-variance-whatsapp-business.svg',
  },
  {
    channel_name: t('EMAIL'),
    value: 'EMAIL',
    icon: '/assets/icons/navbar/ic-variance-mail.svg',
  },
  {
    channel_name: t('LIVE_CHAT'),
    value: 'LIVE_CHAT',
    icon: '/assets/icons/navbar/ic-variance-livechat.svg',
  },
  {
    channel_name: t('DID_VOICE'),
    value: 'VOICE',
    icon: '/assets/icons/navbar/ic-variance-voice.svg',
  },
];

export const emailStep1Data = (t: any) => [
  {
    channel_name: t('MICROSOFT'),
    value: 'microsoft',
    icon: '/assets/icons/navbar/ic-microsoft.svg',
  },
  {
    channel_name: t('GOOGLE'),
    value: 'google',
    icon: '/assets/icons/navbar/ic-gmail.svg',
  },
  {
    channel_name: t('OTHER_PROVIDERS'),
    value: 'other_provider',
    icon: '/assets/icons/navbar/ic-mail.svg',
  },
];

export const _campaignList = campaignListData.map((_, index) => ({
  ..._,
  id: _mock.id(index),
}));

export const _accountList = accountListData.map((_, index) => ({
  ..._,
  id: _mock.id(index),
}));

export const _templateList = templatesData.map((_, index) => ({
  ..._,
  id: _mock.id(index),
  templateName: _.title,
  templateMsg: _.message,
}));

export const _audienceList = audienceData.map((_, index) => ({
  ..._,
  id: _mock.id(index),
}));

export const _planList = (t: any) =>
  planlistData(t).map((_, index) => ({
    ..._,
    id: _mock.id(index),
  }));

export const _channelList = channelListData.map((_, index) => ({
  ..._,
  id: _mock.id(index),
}));

export const labels = [
  {
    labelName: 'Support',
    labelColor: 'warning',
    labelDescription: 'This is a support ticket',
  },
  {
    labelName: 'Sales',
    labelColor: 'primary',
    labelDescription: 'This is a sales-related ticket',
  },
  {
    labelName: 'Whatsapp',
    labelColor: 'secondary',
    labelDescription: 'This is a WhatsApp-related ticket',
  },
  {
    labelName: 'Billing',
    labelColor: 'error',
    labelDescription: 'This is a billing-related ticket',
  },
  {
    labelName: 'Technical',
    labelColor: 'info',
    labelDescription: 'This is a technical issue ticket',
  },
  {
    labelName: 'Feedback',
    labelColor: 'success',
    labelDescription: 'This is a customer feedback ticket',
  },
  {
    labelName: 'Urgent',
    labelColor: 'error',
    labelDescription: 'This is an urgent issue ticket',
  },
  {
    labelName: 'Feature Request',
    labelColor: 'success',
    labelDescription: 'This is a feature request ticket',
  },
  {
    labelName: 'Bug',
    labelColor: 'error',
    labelDescription: 'This is a bug report ticket',
  },
  {
    labelName: 'General Inquiry',
    labelColor: 'info',
    labelDescription: 'This is a general inquiry ticket',
  },
];
